import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import SegmentFields from './Fields'

const Create = ({ form }: SBRMFormActionProps) => <SegmentFields form={form} />

export default Create
